import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';
import TextUtility from '../../../common/utility/TextUtility';

export default function CopyrightCollectFormView4EmailPreviewPopup({
  previewEmailSubject,
  previewEmailBody,
  onClose,
} : {
  previewEmailSubject: string,
  previewEmailBody: string,
  onClose: () => void,
}) {
  return (
    <PopupContainer title="メール文章確認" onClose={() => onClose()}>
      <div className="list__body">
        <p>
          件名：
          <br />
          {previewEmailSubject}
          <br />
          <br />
          ---------------------------------------
          <br />
          本文：
          <br />
          <br />
          <br />
          {TextUtility.nl2br(previewEmailBody)}
        </p>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="cancel" onClick={() => onClose()}>戻る</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
